import $ from 'jquery'

export class Header {
  constructor($container) {
    this.$container = $container

    this.handleLoadUpdateBackground()
  }

  handleLoadUpdateBackground(e) {
    let allBackgrounds = this.$container.data('backgrounds')

    if (!allBackgrounds || allBackgrounds.length === 0) {
      return
    }

    let hasVideo = false
    let indexBg = Math.floor(Math.random() * allBackgrounds.length);
    let currentBg = allBackgrounds[indexBg]

    if (currentBg['is_negative']) {
      this.$container.addClass('negative')
    } else {
      this.$container.removeClass('negative')
    }

    if (currentBg['desktop']['media_type'] === 'video') {
      this.addVideoToContainer(currentBg['desktop']['video'], currentBg['mobile']['video_overlay'], 'desktop')
      hasVideo = true
    }

    if (currentBg['desktop']['media_type'] === 'image') {
      this.$container.addClass('bg-cover')
      this.$container.css('--bg-img-d', 'url(' + currentBg['desktop']['image'] + ')')
    }

    if (currentBg['desktop']['media_type'] === 'player') {
      this.addPlayerToContainer(currentBg['desktop']['player'], currentBg['desktop']['video_overlay'], 'desktop')
      hasVideo = true
    }

    if (currentBg['mobile']['media_type'] === 'video') {
      this.addVideoToContainer(currentBg['mobile']['video'], currentBg['mobile']['video_overlay'], 'mobile')
      hasVideo = true
    }

    if (currentBg['mobile']['media_type'] === 'image') {
      this.$container.addClass('bg-cover')
      this.$container.css('--bg-img-m', 'url(' + currentBg['mobile']['image'] + ')')
    }

    if (currentBg['mobile']['media_type'] === 'player') {
      this.addPlayerToContainer(currentBg['mobile']['player'], currentBg['mobile']['video_overlay'], 'mobile')
      hasVideo = true
    }

    if (allBackgrounds[indexBg]['content']) {
      this.$container.find('.header-wrapper').html(allBackgrounds[indexBg]['content'])
    }

    if (hasVideo) {
      this.handleVideoSize()
      $(window).on('resize', this.handleVideoSize.bind(this))
    }
  }

  handleVideoSize() {
    let ratio = 16 / 9
    let videoRatio = this.$container.width() / this.$container.height()

    if (videoRatio < ratio) {
      this.$container.find('.header-video video, .header-video iframe').css({
        width: 'auto',
        height: '100%'
      })
    } else {
      this.$container.find('.header-video video, .header-video iframe').css({
        width: '100%',
        height: 'auto'
      })
    }
  }

  addVideoToContainer(url, overlayVideo, device) {
    let $video = $(`<video autoplay loop muted playsinline class="header-video ${device}"><source src="${url}" type="video/mp4"></video>`)

    this.$container.prepend($video)

    $video.after(`<div class="header-overlay ${device} overlay-${overlayVideo}"></div>`)
    $video.wrap(`<div class="header-video video ${device}"></div>`)
  }

  addPlayerToContainer(iframe, overlayVideo, device) {
    let $iframe = $(iframe)

    this.$container.prepend($iframe)

    let src = $iframe.attr('src')

    if (src.indexOf('?') !== -1) {
      src += '&'
    } else {
      src += '?'
    }
    src += 'autoplay=1&mute=1&loop=1&controls=0&modestbranding&disablekb=1&showinfo=0&rel=0&playsinline=1'

    $iframe.attr('src', src)
    $iframe.after(`<div class="header-overlay ${device} overlay-${overlayVideo}"></div>`)
    $iframe.wrap(`<div class="header-video iframe ${device}"></div>`)
  }
}
